import { ExtendedMessageType, ExtendedChannel } from '../types';
import { aggregateChannelIds } from './aggregateChannelIds';
import { filterByChannelIds } from './filterByChannelIds';

const normalizeSearchString = (value: string) => value.trim().toLowerCase();

const byName = (query: string) => (namedEntity: { name: string }) =>
  namedEntity.name.toLowerCase().includes(normalizeSearchString(query));

export const filterBySearch = (
  search: string,
  channels: ExtendedChannel[],
  messageTypes: ExtendedMessageType[],
): [ExtendedChannel[], ExtendedMessageType[]] => {
  // Find matching message types + channels
  const matchingMessageTypes = messageTypes.filter(byName(search));
  const matchingChannels = channels.filter(byName(search));

  // Aggregate matching channels and channels containing matching message types
  const matchingChannelIds = aggregateChannelIds(matchingMessageTypes, matchingChannels);

  return [filterByChannelIds(channels, matchingChannelIds), matchingMessageTypes];
};
